// extracted by mini-css-extract-plugin
export default {"divider":"itemFlow_document_divider__pezQ0","wrapper":"itemFlow_document_wrapper__RkC24"};